/** @format */

import imageConstants from './imagePaths';

const i18Prefix = '_common:entities.eventCategory.list';
const listId = {
    SPORTS: 'KZFzniwnSyZfZ7v7nE',
    CONCERTS: 'KZFzniwnSyZfZ7v7nJ',
    ARTS: 'KZFzniwnSyZfZ7v7na',
    FAMILY: 'KnvZfZ7vA1n',
    OTHER: 'KZAyXgnZfZ7v7lt',
    ALL: 'ALL',
};

export default {
    LIST_ID: {
        SPORTS: listId.SPORTS,
        CONCERTS: listId.CONCERTS,
        ARTS: listId.ARTS,
        FAMILY: listId.FAMILY,
        OTHER: listId.OTHER,
        ALL: listId.ALL,
    },
    LIST: [
        {
            ID: listId.SPORTS,
            FALLBACK: imageConstants.FALLBACKS.SPORTS,
            i18nKey: i18Prefix + '.sports',
        },
        {
            ID: listId.CONCERTS,
            FALLBACK: imageConstants.FALLBACKS.CONCERTS,
            i18nKey: i18Prefix + '.concerts',
        },
        {
            ID: listId.ARTS,
            FALLBACK: imageConstants.FALLBACKS.ARTS,
            i18nKey: i18Prefix + '.arts',
        },
        {
            ID: listId.FAMILY,
            FALLBACK: imageConstants.FALLBACKS.FAMILY,
            i18nKey: i18Prefix + '.family',
        },
        {
            ID: listId.OTHER,
            FALLBACK: imageConstants.FALLBACKS.OTHER,
            i18nKey: i18Prefix + '.otherEvents',
        },
        {
            ID: listId.ALL,
            FALLBACK: imageConstants.FALLBACKS.ALL,
            i18nKey: i18Prefix + '.all',
        },
    ],
    DEFAULT_FALLBACK: imageConstants.FALLBACKS.OTHER_EVENTS,
};
